import React, { InputHTMLAttributes, useEffect, useRef } from "react";

import { useField } from "@unform/core";

import {
  CheckboxContainer,
  CheckboxInput,
  Label,
  LabelContainer,
  LabelPrice,
} from "./styles";

interface ICheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  price: string;
}

const CheckboxStyled: React.FC<ICheckboxProps> = ({
  name,
  value,
  label,
  price,
  className,
  defaultChecked: defaultCheckedInput,
  ...rest
}: ICheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField } = useField(name);
  const defaultChecked =
    defaultValue !== undefined ? defaultValue : defaultCheckedInput;

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.checked;
      },
      clearValue: (ref) => {
        ref.current.checked = defaultChecked;
      },
      setValue: (ref, value) => {
        ref.current.checked = value;
      },
    });
  }, [defaultValue, fieldName, registerField, defaultChecked]);

  const onClickContainer = () => inputRef.current.click();

  return (
    <CheckboxContainer className={className} onClick={onClickContainer}>
      <CheckboxInput
        value={value}
        ref={inputRef}
        id={fieldName}
        type="checkbox"
        defaultChecked={defaultChecked}
        {...rest}
      />

      <LabelContainer>
        <Label id={fieldName}>{label}</Label>
        <LabelPrice>{price}</LabelPrice>
      </LabelContainer>
    </CheckboxContainer>
  );
};

export default CheckboxStyled;
